import React from "react";

export default function LocationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
    >
      <path
        fill="#343434"
        fillRule="evenodd"
        d="M15 2.5a7.837 7.837 0 00-.938 15.625V23.5a.937.937 0 101.876 0v-5.375A7.837 7.837 0 0015 2.5zm-.813 4.338a2.613 2.613 0 00-2.612 2.6.937.937 0 11-1.875 0 4.488 4.488 0 014.488-4.475.937.937 0 110 1.875zm5.588 12.9a.95.95 0 011.25-.413 4.275 4.275 0 012.725 3.65c0 2.763-3.75 4.85-8.75 4.85s-8.75-2.087-8.75-4.85a4.275 4.275 0 012.725-3.587.94.94 0 01.85 1.675c-1.1.562-1.725 1.262-1.725 1.912 0 1.35 2.963 2.9 6.912 2.9 3.95 0 6.9-1.562 6.9-2.975 0-.662-.624-1.35-1.724-1.912a.937.937 0 01-.413-1.25z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
